import axios from "axios";
import { getLsData, setLsData } from "../service/lsencryption";
import React from "react";
import swal from "sweetalert";
import { logError } from "../helpers/auth";

/**
 * dev: https://dev.nextgen.imonitorplus.com/nextgendevservice/v1.0/
 * QA: https://qa.nextgen.imonitorplus.com/qaservice/v1.0/
 * prod: https://v1.nextgen.imonitorplus.com/service/v1.0/
 * uat: https://uat.nextgen.imonitorplus.com/uatservice/v1.0/
 * uatv1: https://uatv1.imonitorplus.com/uatservice/v1.0/
 * staging: https://stagingv1.imonitorplus.com/service/v1.0/
 * const mainURL = "https://ng.imonitorplus.com/service/v1.0/";
 * dev env: https://dev.v1nextgen.imonitorplus.com/service/v1.0/
 */

const mainURL = "https://dev.v1nextgen.imonitorplus.com/service/v1.0/";
// const mainURL = "https://oneimpact.mz.faihpp.org/service/v1.0/";
export const WhatsappBotUrl = "https://wa.link/182zk0";
if(!getLsData('ServiceUrl')){
  setLsData('ServiceUrl', mainURL);
  }else if(getLsData('ServiceUrl') && getLsData('ServiceUrl') != mainURL){
    console.log("ServiceUrl changed!")
    setLsData('ServiceUrl', mainURL);
    setLsData('NewServiceUrl', true);
  }


const googleplacesAPI = "https://maps.googleapis.com/maps/api/place/nearbysearch/json?";


/**
 * _1: salt
 * _2: iv
 */

let header = {
  "Content-Type": "application/json",
};

class RestServices {
  getRequest(url) {
    return axios({
      method: "get",
      url: mainURL + url,
      headers: header,
    })
      .then((response) => {
        console.log("getRequest res>>", response.status);
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.log("getRequest err>>", error);
        return Promise.reject(error.message);
      });
  }
  postRequest(url, data, customheaders,msg) {
    try {
      console.log("msg",msg)
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova && msg == 'slowinternet') {    
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from postRequest")
        }
        console.log("aborted due to timeout");
      }, 5000);
      console.log("check online2", navigator.onLine);
      return axios({
        method: "post",
        url: mainURL + url,
        cancelToken: source.token,
        headers: Object.assign({ ...header, ...customheaders }),
        data: data,
      })
        .then((response) => {
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "postRequest",
        error: err,
      };
      logError(errorObj);
    }
  }
  notiRequest(url, data, customheaders) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from notiRequest")
        }
        console.log("aborted due to timeout");
      }, 5000);
      return axios({
        method: "post",
        url: url,
        cancelToken: source.token,
        headers: Object.assign({ ...header, ...customheaders }),
        data: data,
      })
        .then((response) => {
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "notiRequest",
        error: err,
      };
      logError(errorObj);
    }
  }
  putRequest(url, data, customheaders) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection","short","center")
          console.log("Experiencing slow internet connection from putRequest")
        }
        console.log("aborted due to timeout");
      }, 5000);
      return axios({
        method: "put",
        url: mainURL + url,
        cancelToken: source.token,
        headers: Object.assign({ ...header, ...customheaders }),
        data: data,
      })
        .then((response) => {
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "putRequest",
        error: err,
      };
      logError(errorObj);
    }
  }
  multiPart(url, data) {
    this.setAuth(url);
    return axios
      .post(mainURL + url, data, {
        headers: header,
      })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.log(error);

        return Promise.reject(error.message);
      });
  }
  newpostRequest(url, data, customheaders,msg) {
    try {
      console.log("msg",msg)
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova && msg == 'slowinternet') {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from newpostRequest")
        }
        console.log("aborted due to timeout");
      }, 5000);
      return axios({
        method: "post",
        url: mainURL + url,
        cancelToken: source.token,
        headers: Object.assign({ ...header, ...customheaders }),
        data: data,
      })
        .then((response) => {
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.resolve(error);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "newpostRequest",
        error: err,
      };
      logError(errorObj);
    }
  }

  getGoogleNearme(url) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from getGoogleNearme")
        }
        console.log("aborted due to timeout");
      }, 5000);
      return axios({
        method: "get",
        cancelToken: source.token,
        url: googleplacesAPI + url,
        headers: header,
      })
        .then((response) => {
          //this.hideLoader();
          console.log("getRequest res>>", response.status);
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          //this.hideLoader();
          console.log("getRequest err>>", error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "getGoogleNearme",
        error: err,
      };
      logError(errorObj);
    }
  }

  getBotResponse(params) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from getBotResponse")
        }
        console.log("aborted due to timeout");
      }, 5000);
      console.log("inside service getBotResponse");
      return axios({
        method: "post",
        url: params.url,
        cancelToken: source.token,
        data: params.text,
      })
        .then((response) => {
          //this.hideLoader();
          console.log("getRequest res>>", response.status);
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          //this.hideLoader();
          console.log("getRequest err>>", error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "getBotResponse",
        error: err,
      };
      logError(errorObj);
    }
  }

  getDataFromUrl(params) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from getDataFromUrl")
        }
        console.log("aborted due to timeout");
      }, 5000);
      console.log("inside service getDataFromUrl");
      return axios({
        method: "get",
        url: params.url,
        cancelToken: source.token,
        data: params.text,
      })
        .then((response) => {
          //this.hideLoader();
          console.log("getRequest res>>", response.status);
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          //this.hideLoader();
          console.log("getRequest err>>", error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.reject(error.message);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "getDataFromUrl",
        error: err,
      };
      logError(errorObj);
    }
  }

  crossApipostRequest(url, data, customheaders) {
    try {
      let source = axios.CancelToken.source();
      let timmy = setTimeout(() => {
        // source.cancel();
        if (window.cordova) {
          // window.plugins.toast.show("Experiencing slow internet connection", "short", "center");
          console.log("Experiencing slow internet connection from crossApipostRequest")
        }
        console.log("aborted due to timeout");
      }, 5000);
      return axios({
        method: "post",
        url: url,
        cancelToken: source.token,
        headers: Object.assign({ ...header, ...customheaders }),
        data: data,
      })
        .then((response) => {
          clearTimeout(timmy);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          if (axios.isCancel(error)) {
            swal({
              title: "Experiencing slow internet",
              icon: "warning",
              button: "ok",
            }).then(() => {});
            console.log("AxiosCancel: caught cancel");
          } else {
            throw error;
          }
          return Promise.resolve(error);
        });
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: "API/service",
        method: "crossApipostRequest",
        error: err,
      };
      logError(errorObj);
    }
  }
  render() {
    return <></>;
  }
}
const service = new RestServices();
export default service;
